import { Action } from './Action.js';
/**
 * @class ExitFullscreen
 * @extends Action
 * @classdesc �������� ����� �� �������������� ������
 * */
export class ExitFullscreen extends Action {
    execute() {
        const fullDoc = document.fullscreenElement ||
            document.mozFullscreenElement ||
            document.webkitFullscreenElement;

        if (window.ipc) {
            window.ipc.get().sendSync("server", "setFullscreen", false);
            return;
        }

        if (fullDoc) {
            document.exitFullscreen();
        }
    }
}